import { AssetType as InlineAssetType } from '@/inline-playlist/src/types/AssetType';
import {
  AssetType,
  CuratedAssetType,
} from '@vimond/services/content-discovery';

export const getPosterImageLocation = ({
  asset,
  isVertical,
}: {
  asset: InlineAssetType | AssetType | CuratedAssetType;
  isVertical?: boolean;
}): string => {
  const preferredImageLocation = isVertical
    ? 'portal-portrait-cover'
    : 'portal-landscape-cover';
  const imageLocation =
    (asset.content ?? asset)?.images?.templates.locations.find(
      (l) => l === preferredImageLocation,
    ) ?? 'main';

  return imageLocation;
};

export const getDefaultImageSrc = (
  asset: InlineAssetType | AssetType | CuratedAssetType,
) => {
  const isCuratedAsset = 'content' in asset && asset.content !== undefined;
  const assetItem = isCuratedAsset ? asset.content : asset;
  return assetItem?.images?.defaultUrl ?? '';
};

export const getPlayerPosterImageUrl = ({
  asset,
  height,
  verticalPlayer,
  width,
}: {
  asset: InlineAssetType | AssetType | CuratedAssetType;
  height?: number;
  verticalPlayer?: boolean;
  width?: number;
}) => {
  const imageLocation = getPosterImageLocation({
    asset,
    isVertical: verticalPlayer,
  });
  const imageUrl = getDefaultImageSrc(asset);
  const posterUrl =
    imageUrl +
    `?location=${imageLocation}${height ? `&height=${height}` : ''}${width ? `&width=${width}` : ''}`;

  return posterUrl;
};
